<script setup>
import { onMounted } from 'vue';
import { ClusterOverview } from '@phx-styleguides/iwc';

import CollectionSlider from '@maison/components/organisms/slider/CollectionSlider.vue';
import PictureLazy from '@maison/components/common/PictureLazy.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  clusters: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

onMounted(() => {
  const verticalCluster = document.getElementById(props.id);

  if (verticalCluster) {
    new ClusterOverview(verticalCluster);
  }
});
</script>

<template>
  <div class="grid__items grid-layout grid--spacing-3 vertical-cluster__grid vertical-cluster__content-wrapper">
    <div
      v-for="(cluster, i) in clusters"
      :id="cluster.id"
      :key="cluster.id"
      :class="['vertical-cluster__content', { 'vertical-cluster__content--visible': i === 0 }]"
      :data-index="i + 1"
    >
      <div class="vertical-cluster__infos">
        <h2 class="vertical-cluster__title heading-large">
          <span>{{ cluster.title }}</span>
        </h2>

        <div class="specs-table">
          <div class="specs-table__row title-caption">
            <span class="specs-table__row-left">{{ $t('VerticalCluster.sizes') }}</span>
            <span class="specs-table__row-right">{{ cluster.sizes }}</span>
            <hr class="divider" />
          </div>

          <div class="specs-table__row title-caption">
            <span class="specs-table__row-left">
              {{ $t('VerticalCluster.variants', { count: cluster.productsCount }) }}
            </span>
          </div>
        </div>
      </div>

      <div class="vertical-cluster__slider md:hidden">
        <collection-slider :id="`${id}-${cluster.id}-slider`" :slides="cluster.slides" />

        <a :href="cluster.href" class="btn vertical-cluster__collection-cta btn--fade">
          <span class="btn__text">{{ $t('VerticalCluster.viewCollection') }}</span>
        </a>
      </div>

      <a :href="cluster.href" class="btn vertical-cluster__collection-cta max-sm:hidden btn--fade">
        <span class="btn__text">{{ $t('VerticalCluster.viewCollection') }}</span>
      </a>
    </div>
  </div>

  <div class="grid__items grid-layout grid--spacing-3 vertical-cluster__grid vertical-cluster__medias">
    <div
      v-for="(cluster, i) in clusters"
      :key="`${id}-${cluster.id}-${i}-media`"
      class="vertical-cluster__picture-wrapper"
      :data-index="i + 1"
    >
      <div class="picture picture--contain vertical-cluster__picture">
        <picture-lazy v-bind="cluster.image" />
      </div>

      <div class="vertical-cluster__slider max-sm:hidden">
        <collection-slider :id="`${id}-${cluster.id}-slider-media`" :slides="cluster.slides" />
      </div>
    </div>
  </div>
</template>
